var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.382 13.464-.949-1.332L2.881 1.56h3.254l6.1 8.532.948 1.332 7.924 11.088h-3.254l-6.471-9.048ZM21.107 0 13.35 8.82 7.144 0H0l9.377 13.344L0 24h2.113l8.2-9.312L16.856 24H24l-9.725-13.836L23.22 0h-2.113Z",
  fill: "currentColor"
})));
export default SvgX;